import { WalletFilterType } from "./enums";

export enum WalletApiRoutes {
  list = "/api/v1/wallet/list",
  currency = "/api/v1/wallet/currency/list",
  withAmount = "/api/v1/wallet/list/with-amount",
  create = "/api/v1/wallet/create",
  chain = "/api/v1/wallet/chain",
  deposit = "/api/v1/wallet/deposit",
  withdrawal = "/api/v1/wallet/withdraw/store",
  verification = "/api/v1/wallet/withdraw/verification",
  history = "/api/v1/wallet/history",
  adminHistory = "/api/v1/admin/wallet/history",
  totalBalance = "/api/v1/wallet/balance",
  exchange = "/api/v1/wallet/exchange/store",
  verificationExchange = "/api/v1/wallet/exchange/verification",
  tradingPairs = "/api/v1/wallet/exchange/pair",
  ticker = "/api/v1/rates/ticker",
}

export interface WalletProjectUrlGenerator {
  list(userId: number, type: WalletFilterType): string;
  currency(): string;
  withAmount(userId: number, type: WalletFilterType): string;
  create(): string;
  chains(coinId: number): string;
  depositAddress(symbol: string, chain: string): string;
  withdrawal(): string;
  verification(): string;
  history(): string;
  adminHistory(): string;
  totalBalance(): string;
  exchange(): string;
  verificationExchange(): string;
  tradingPairs(from: number, to: number): string;
  ticker(): string;
}

export class WalletUrlGenerator implements WalletProjectUrlGenerator {
  list(userId: number, type: WalletFilterType): string {
    if (type) {
      return `${WalletApiRoutes.list}?user_id=${userId}&filter[type]=${type}`;
    }

    return `${WalletApiRoutes.list}?user_id=${userId}`;
  }

  currency(): string {
    return WalletApiRoutes.currency;
  }

  withAmount(userId: number, type: WalletFilterType): string {
    if (type) {
      return `${WalletApiRoutes.withAmount}?user_id=${userId}&filter[type]=${type}`;
    }

    return `${WalletApiRoutes.withAmount}?user_id=${userId}`;
  }

  create(): string {
    return WalletApiRoutes.create;
  }

  chains(coinId: number): string {
    return `${WalletApiRoutes.chain}?coin_id=${coinId}`;
  }

  depositAddress(symbol: string, chain: string): string {
    return `${WalletApiRoutes.deposit}?symbol=${symbol}&chain=${chain}`;
  }

  withdrawal(): string {
    return WalletApiRoutes.withdrawal;
  }

  verification(): string {
    return WalletApiRoutes.verification;
  }

  history(): string {
    return WalletApiRoutes.history;
  }

  adminHistory(): string {
    return WalletApiRoutes.adminHistory;
  }

  totalBalance(): string {
    return WalletApiRoutes.totalBalance;
  }

  exchange(): string {
    return WalletApiRoutes.exchange;
  }

  verificationExchange(): string {
    return WalletApiRoutes.verificationExchange;
  }

  tradingPairs(from: number, to: number): string {
    return `${WalletApiRoutes.tradingPairs}?from=${from}&to=${to}`;
  }

  ticker(): string {
    return WalletApiRoutes.ticker;
  }
}
